<template lang="pug">
div
  slot(name="activator" :toggle="toggle")
    v-btn(small color='primary' 
      @click="toggle" 
      :disabled="disabledAccept"
      outlined
    ) accept
  accept-dialog(
    v-model="showing" 
    @okClicked="acceptHandler"
  ).mr-2
</template>
<script>
import { CBR_STATUS } from '../core/candidates-const'
import errorsMixin from '@/mixins/errors.mixin'

export default {
  mixins: [errorsMixin],
  props: {
    activeItems: {
      required: true,
      type: Array
    },
    disabled: Boolean
  },
  data: () => ({
    showing: false
  }),

  computed: {
    disabledAccept() {
      if(this.disabled) return true
      if(!this.activeItems.length) return true
      return false
    },
  },

  inject: ['svc'],

  methods: { 
    toggle() {
      if(this.disabledAccept) return
      this.showing = !this.showing
    },

    Svc() {
      return this.svc()
    },

    acceptHandler(cbrUser) {
      this.toggle()
      this.accept(cbrUser)
    },

    async accept(payload) {
      try {
        let ids = this.activeItems.map(item => item.ID)
        let res = await this.Svc().accept(ids, payload)
        this.$notify({text: 'Started accepting', type: 'success'})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    async testCandidateHandler(cbrUser) {
      let payload = {...cbrUser, isTest: true}
      this.accept(payload)
      this.toggle()
    }
  },

  components: {
    acceptDialog: () => import('./CandidateAcceptModalBulk.vue')
  }
}
</script>